export default "__VITE_ASSET__YkDhQhiD__"